const buttonStyle = {
  textAlign: 'center',
  paddingTop: '50px',
};


export default {
  buttonStyle,
};



// WEBPACK FOOTER //
// ./src/scenes/Login/style.js